export function numberObjectMapper(
    number?: string | null,
    code?: string | null,
): {
    number: string;
    dialingCode: string;
    countryCode: string;
} {
    if (!number || !code) {
        return {
            number: '',
            dialingCode: '',
            countryCode: '',
        };
    }

    if (!code) {
        return {
            number: number.replace(/^0+/, ''),
            dialingCode: '',
            countryCode: '',
        };
    }

    return {
        number: number.replace(/^0+/, ''),
        dialingCode: code.substring(code.indexOf('/') + 1, code.length),
        countryCode: code.substring(0, code.indexOf('/')),
    };
}
